import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface AccountRequestModel {
    firstName: string;
    lastName: string;
    emailAddress: string;
    existingCustomer: string;
    companyName: string;
    accountNumber: string;
    tradeOrDbaName: string;
    companyAddress: CompanyAddress;
    phoneNumber: string;
    faxNumber: string;
    location:string;
}

export interface CompanyAddress {
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    countryId?: string;
    stateId?: string;
    stateName?: string;
    city?: string;
    postalCode?: string;
}

type AccountRequestFormParameter = {
    accountRequestModel: AccountRequestModel;
} & HasOnSuccess & HasOnError;

interface AccountRequestFormApiParameter extends ApiParameter {
    firstName: string;
    lastName: string;
    emailAddress: string;
    existingCustomer: string;
    companyName: string;
    accountNumber: string;
    tradeOrDbaName: string;
    companyAddress: CompanyAddress;
    phoneNumber: string;
    faxNumber: string;
    location:string;
}

type HandlerType = ApiHandlerDiscreteParameter<AccountRequestFormParameter, AccountRequestFormApiParameter>;

const accountRequestFormUrl = "/api/v1/account/request"

export function ucsAccountRequestForm(parameter: AccountRequestFormApiParameter) {
    return post<AccountRequestFormApiParameter, void>(`${accountRequestFormUrl}`, parameter);
}


export const PopulateApiParameter: HandlerType = props => {
    // TODO: Handle PopulateApiParameter logic 
    props.apiParameter = {
        firstName: props.parameter.accountRequestModel.firstName,
        lastName: props.parameter.accountRequestModel.lastName,
        emailAddress: props.parameter.accountRequestModel.emailAddress,
        existingCustomer: props.parameter.accountRequestModel.existingCustomer,
        accountNumber: props.parameter.accountRequestModel.accountNumber,
        companyName: props.parameter.accountRequestModel.companyName,
        tradeOrDbaName: props.parameter.accountRequestModel.tradeOrDbaName,
        companyAddress: props.parameter.accountRequestModel.companyAddress,
        phoneNumber: props.parameter.accountRequestModel.phoneNumber,
        faxNumber: props.parameter.accountRequestModel.faxNumber,
        location : props.parameter.accountRequestModel.location,
    }
}

export const SendDataToApi: HandlerType = async props => {
    try {
        await ucsAccountRequestForm(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.();
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};


export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const ucsAccountRequest = createHandlerChainRunner(chain, "ucsAccountRequest");
export default ucsAccountRequest;